import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import {
  BrandTypeSelectList,
  InspectionForm,
  InspectionView,
  ModelSelectList,
} from '../inspection/components';
import Redirect from 'react-router-dom/es/Redirect';

/**
 * A printable version of the InspectionView with prev / next buttons disabled.
 * The printable version could be formatted for printout too. Now the formatting
 * is left as a responsibility of a chromium-puppeteer process on the server
 * side, which cleans out items with nonprintable styles.
 * 
 * @param {*} props 
 */
const InspectionViewPrintable = props => {
  return (<InspectionView
      printable={true}
      {...props} />);
}

const Inspection = props => {
  return (
    <Switch>
      <Route
        exact
        path="/inspection/new"
        render={props => {
          return <BrandTypeSelectList {...props} backPath="/" />;
        }}
      />

      <Route
        exact
        path="/inspection/new/:brandId/:typeId"
        render={props => {
          return <ModelSelectList {...props} backPath="/inspection/new" />;
        }}
      />

      <Route path="/inspection/view/:id?/:tab?" component={InspectionView} />

      <Route path="/inspection/print/:id?/:tab?" component={InspectionViewPrintable} />

      <Route
        exact
        path="/inspection/edit/:id/:tab?"
        render={props => <InspectionForm {...props} backPath="/" />}
      />

      <Route path="/inspection">
        <Redirect to="/" />
      </Route>
    </Switch>
  );
};

Inspection.propTypes = {
  childRoutes: PropTypes.array,
};

export default Inspection;



// WEBPACK FOOTER //
// ./src/modules/pages/Inspection.js